import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// In production, missing Supabase config is a hard failure: the previous
// behaviour of silently constructing a client with empty strings let the app
// boot into a half-broken state where signup, login, and auth-gated routes
// would fail mysteriously. Fail loudly at module load instead so the operator
// sees the misconfiguration before users do.
//
// In dev we keep the warning behaviour so contributors can boot the app
// against a partially configured `.env` for offline work.
if (!supabaseUrl || !supabaseAnonKey) {
  const message =
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Auth, sync, and edge-function calls will not work.';
  if (import.meta.env.PROD) {
    throw new Error(message);
  }
  console.warn(message);
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
);
